import Color from '@/Enums/Color.enum';
import { Box } from '@mui/material';

const clickUrlString = '{{CLICK_URL}}';
const clickUrlEscString = '{{CLICK_URL_ESC}}';

const ClickTagWarning = () => (
  <Box sx={{ fontSize: '14px', background: Color.WarningYellow, borderRadius: '8px', padding: '4px' }}>
    <span>
      Creative does not include either the <code>{clickUrlString}</code> or <code>{clickUrlEscString}</code> macros for
      tracking clicks. Clicks will not be tracked
    </span>
  </Box>
);

export default ClickTagWarning;
